<ng-template #dialogTemplate>
  <h1 #customHeaderContent mat-dialog-title>
    <ng-content select="[ubi-dialog-header]"></ng-content>
  </h1>
  <ng-template *ngIf="customHeaderContent.childNodes.length == 0 then headerDefaultTemplate"></ng-template>
  <div mat-dialog-content #content>
    <ng-content select="[ubi-dialog-content]"></ng-content>
  </div>
  <ng-template *ngIf="content.childNodes.length == 0 then contentDefaultTemplate"></ng-template>

  <div #customActionContent mat-dialog-actions>
    <ng-content #content select="[ubi-dialog-action]"></ng-content>
  </div>
  <ng-template *ngIf="configurations.type === 'confirm' && customActionContent.childNodes.length == 0 then confirmActionTemplate"></ng-template>
  <ng-template *ngIf="configurations.type === 'alert' && customActionContent.childNodes.length == 0 then alertActionTemplate"></ng-template>
  <ng-template #alertActionTemplate>
    <div mat-dialog-actions>
      <button  class="mat-stroked-button btn-large" color="primary" (click)="close()">{{configurations.okTitle}}</button>
    </div>
  </ng-template>

  <ng-template #confirmActionTemplate>
    <div mat-dialog-actions>
      <button class="mat-button btn-gradient" color="primary" (click)="submit()">{{configurations.submitTitle}}</button>
      <button class="mat-stroked-button" color="secondary" (click)="close()">{{configurations.cancelTitle}}</button>
    </div>
  </ng-template>

  <ng-template #headerDefaultTemplate>
    <h1 mat-dialog-title>
      {{configurations.title}}
    </h1>
  </ng-template>

  <ng-template #contentDefaultTemplate>
    <div mat-dialog-content>
      {{configurations.content}}
    </div>
  </ng-template>
</ng-template>
